import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: fontSize.h3,
    color: colors.title,
    display: 'inline-block',
    '& *': {
      fontFamily: 'inherit',
      color: 'inherit',
      fontSize: 'inherit',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 35,
    },
  },
}));

const H3 = ({ className, children }) => {
  const classes = useStyles();
  return <h3 className={cn(classes.root, className)}>{children}</h3>;
};

H3.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default H3;
